import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { createContext, useContext } from 'react';
import { PAGE_SIZES } from 'ui/paginationFooter';
import noop from 'utils/noop';
import { CREATOR_FILTER_TABS } from '../constants';
import { CreatorFilter } from '../types';

type QueryContextState = {
  creatorFilter: CreatorFilter;
  setCreatorFilter: (creatorFilter: CreatorFilter) => void;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  currentPage: number;
  setCurrentPage: (currentPage: number) => void;
  sortBy: string;
  setSortBy: (sortBy: string) => void;
  sortDirection: SORT_DIRECTIONS;
  setSortDirection: (sortDirection: SORT_DIRECTIONS) => void;
  refetchViews: boolean;
  toggleRefetchViews: () => void;
};

export const defaultQueryContextState = {
  creatorFilter: CREATOR_FILTER_TABS[0].id,
  setCreatorFilter: noop,
  searchTerm: '',
  setSearchTerm: noop,
  pageSize: PAGE_SIZES[0],
  setPageSize: noop,
  currentPage: 1,
  setCurrentPage: noop,
  sortBy: 'updatedAt',
  setSortBy: noop,
  sortDirection: SORT_DIRECTIONS.DESCENDING,
  setSortDirection: noop,
  refetchViews: true,
  toggleRefetchViews: noop,
};

export const QueryContext = createContext<QueryContextState>(defaultQueryContextState);

export const useQueryContext = () => useContext(QueryContext);
